import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutBottomFull: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-bottom-full, grid, window"><path d="M20.25 20.25V21H21V20.25H20.25ZM20.25 3.75H21V3H20.25V3.75ZM3.75 3.75V3H3V3.75H3.75ZM3.75 20.25H3V21H3.75V20.25ZM21 20.25V3.75H19.5V20.25H21ZM20.25 3H3.75V4.5H20.25V3ZM3 3.75V20.25H4.5V3.75H3ZM3.75 21H20.25V19.5H3.75V21Z" fill="currentColor"/><path d="M20.25 15H21V13.5H20.25V15ZM3.75 13.5H3V15H3.75V13.5ZM3.75 15H20.25V13.5H3.75V15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLayoutBottomFull;
